/**
 * Sugestões de IA no Consolidador — vocabulário do domínio.
 *
 * Reusa a fila central de curadoria (`aawz_intelligence_suggestions`), a mesma que o CRM usa:
 * mesma tabela, mesmos endpoints de aceitar/editar/recusar, mesmo card. O que muda é só QUAL
 * entidade a sugestão propõe.
 *
 * O discriminador é `tabela_referencia` (+ `operacao`), não um `tipo` novo: `tabela_referencia`
 * já é a chave do `ENTITY_WRITERS` no backend, então categoria nova entra como uma linha em
 * CATEGORIAS, sem migration e sem tocar card, painel ou tela. Categoria que o front ainda não
 * conhece cai em CATEGORIA_FALLBACK em vez de sumir da fila ou renderizar chave crua.
 *
 * `ancoraNoAtivo` diz se a categoria aparece no badge da linha do ativo. Só `ativo_ajuste` ancora:
 * `id_entidade_alvo` é a PK da tabela de referência, e a PK de `app_aplicacao_ativo` é a da
 * movimentação, não a do ativo — ancorar por ela contaria a movimentação na linha errada. A
 * movimentação ancora por outro caminho: o de-para movimentação→ativo em `suggestions-fila.js`,
 * que resolve o `id_ativo_cliente` a partir do índice de movimentações que a tela já carrega. A
 * derivação da categoria fica em `utils/suggestions-categoria/`.
 */
export const TABELA_ATIVO_CLIENTE = 'app_dados_ativos_clientes'
export const TABELA_MOVIMENTACAO = 'app_aplicacao_ativo'

export const TABELAS_DO_CONSOLIDADOR = [TABELA_ATIVO_CLIENTE, TABELA_MOVIMENTACAO]

export const OPERACAO_CREATE = 'create'
export const OPERACAO_EDIT = 'edit'

export const CATEGORIA_ATIVO_AJUSTE = 'ativo_ajuste'
export const CATEGORIA_ATIVO_INCLUSAO = 'ativo_inclusao'
export const CATEGORIA_MOVIMENTACAO = 'movimentacao'
export const CATEGORIA_DESCONHECIDA = 'sugestao_ia'

export const CATEGORIAS = {
  [CATEGORIA_ATIVO_AJUSTE]: {
    label: 'Ajuste no ativo',
    icon: 'edit-2',
    ancoraNoAtivo: true,
  },
  [CATEGORIA_ATIVO_INCLUSAO]: {
    label: 'Novo ativo',
    icon: 'add-circle',
    ancoraNoAtivo: false,
  },
  [CATEGORIA_MOVIMENTACAO]: {
    label: 'Movimentação',
    icon: 'arrow-swap-horizontal',
    ancoraNoAtivo: false,
  },
}

export const CATEGORIA_FALLBACK = {
  label: 'Sugestão da IA',
  icon: 'menu-board',
  ancoraNoAtivo: false,
}
